const comments = [
  { name: '漫画迷小林', text: '用樱花漫画看韩漫真的太爽了！下拉式阅读完全不用等加载，《她的私密生活》一口气刷了五十话，画质清晰排版舒服，已经安利给全宿舍了。', time: '2天前', avatar: 'ri-user-3-line' },
  { name: '追更狂魔阿飞', text: '作为一个追了十几年漫画的老宅，樱花漫画的更新速度真的快！日漫新番当天就能看，国漫推荐也很对我的胃口，收藏夹已经塞不下了哈哈。', time: '3天前', avatar: 'ri-user-smile-line' },
  { name: '深夜读漫人', text: '最喜欢睡前刷几话搞笑日常漫画，解压效果满分。樱花漫画的手机端体验做得很好，躺床上单手操作无压力，下拉即读太方便了。', time: '5天前', avatar: 'ri-moon-clear-line' },
  { name: '悬疑爱好者七七', text: '在樱花漫画发现了超多冷门悬疑推理佳作！之前在其他平台找不到的完结漫画这里都有，而且全本免费，简直是我的精神粮仓。', time: '6天前', avatar: 'ri-search-eye-line' },
  { name: '上班摸鱼王', text: '上班通勤路上看两话，午休再看两话，樱花漫画已经成为我的每日必刷。最近在追一部国漫仙侠新作，画风绝美剧情在线，疯狂安利！', time: '1周前', avatar: 'ri-emotion-happy-line' },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            读者心声
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            漫画爱好者都在说什么
          </h2>
        </div>
        <div className="space-y-4">
          {comments.map((comment, i) => (
            <div key={i} className="bg-background-50 rounded-xl border border-background-200/70 p-5">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${comment.avatar} text-accent-600`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}